import { render, staticRenderFns } from "./Home-index.vue?vue&type=template&id=9a50b4b2&scoped=true"
import script from "./Home-index.vue?vue&type=script&lang=js"
export * from "./Home-index.vue?vue&type=script&lang=js"
import style0 from "./Home-index.vue?vue&type=style&index=0&id=9a50b4b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a50b4b2",
  null
  
)

export default component.exports